export const checkIsAccountPath = pathname => {
  const accountPathRegExp = /\/account[/.+]?/;
  return accountPathRegExp.test(pathname);
};

export const checkIsRegPath = pathname => {
  const accountPathRegExp = /\/registration[/.+]?/;
  return accountPathRegExp.test(pathname);
};
